
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface TermsAndConditionsProps {
  triggerLabel?: string;
  className?: string;
}

const TermsAndConditions = ({ triggerLabel, className = "" }: TermsAndConditionsProps) => {
  const { t } = useTranslation();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="link" className={`text-sm text-[#006B5F] hover:text-[#004a3f] p-0 h-auto font-semibold underline ${className}`}>
          {triggerLabel || t('common.terms')}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md max-h-[80vh] overflow-auto">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-[#006B5F]">
            {t('terms.title')}
          </DialogTitle>
          <DialogDescription className="text-base text-gray-800">
            {t('terms.subtitle')}
          </DialogDescription>
        </DialogHeader>
        
        <div className="mt-4 space-y-4 text-gray-700">
          <p>
            {t('terms.intro')}
          </p>

          <div className="bg-gray-50 p-3 rounded-md border border-gray-200">
            <p className="text-sm text-gray-700">
              {t('terms.company')}
            </p>
          </div>

          <div>
            <h3 className="font-bold text-[#006B5F] mt-4 mb-2">{t('terms.product.title')}</h3>
            <p>
              {t('terms.product.content')}
            </p>
          </div>

          <div>
            <h3 className="font-bold text-[#006B5F] mt-4 mb-2">{t('terms.payment.title')}</h3>
            <p>
              {t('terms.payment.content')}
            </p>
          </div>

          <div>
            <h3 className="font-bold text-[#006B5F] mt-4 mb-2">{t('terms.delivery.title')}</h3>
            <p>
              {t('terms.delivery.content')}
            </p>
          </div>

          <div>
            <h3 className="font-bold text-[#006B5F] mt-4 mb-2">{t('terms.cancellation.title')}</h3>
            <p>
              {t('terms.cancellation.content')}
            </p>
          </div>

          <div>
            <h3 className="font-bold text-[#006B5F] mt-4 mb-2">{t('terms.warranty.title')}</h3>
            <p>
              {t('terms.warranty.content')}
            </p>
          </div>

          <div>
            <h3 className="font-bold text-[#006B5F] mt-4 mb-2">{t('terms.privacy.title')}</h3>
            <p>
              {t('terms.privacy.content')}
            </p>
            <p className="mt-2">
              {t('terms.privacy.more')}
            </p>
          </div>

          <div>
            <h3 className="font-bold text-[#006B5F] mt-4 mb-2">{t('terms.contact.title')}</h3>
            <p>
              {t('terms.contact.content')}<br />
              <a
                href="mailto:Info@omsorgsterapi.dk"
                className="text-[#006B5F] hover:underline"
              >
                Info@omsorgsterapi.dk
              </a>
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TermsAndConditions;
